import { Col, Container, Row } from "react-bootstrap";
import Benefits from "../Membership/Benfits";
import MembershipJoin from "../Membership/MembershipJoin";

export default function PageMembership() {
  return (
    <div className="page-membership">
      <Container>
        <div className="card-with-padding">
          <Row className="jsutify-content-center align-items-center">
            <Col lg={4}>
              <MembershipJoin />
            </Col>
            <Col lg={8}>
              <Benefits />
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}
